module.exports = __webpack_public_path__ + "img/Digte_Morgen-i-Ny-Hellesund.81c51df9.jpg";